import { observer } from 'mobx-react-lite'
import { TxfJobCard } from '@/features/jobs/details/components/TxfJobCard'
import { type TxfJobCardViewModel } from './TxfJobCardViewModel'

export interface TxfJobCardContainerProps {
  vm: TxfJobCardViewModel
}

export const TxfJobCardContainer = observer(function TxfJobCardContainer({
  vm,
}: TxfJobCardContainerProps) {
  return <TxfJobCard onViewInTxf={vm.viewInTxf} />
})
